const ACTION_APPEND = 'append';
const ACTION_REPLACE = 'replace';

export const CaseQuizList = {
  namespaced: true,

  state: {
    caseQuizListLoading: false,
    allQuizzesList: [],
    caseQuizListPagination: {
      current_page: 1,
      per_page: 12,
      total: 0,
      last_page: 1,
    },
    quizList: [],
    currentQuiz: null,
    quizStarted: {
      id: null,
      currentCaseIndex: 0,
    },
  },

  getters: {
    getQuizPaginationData: (state) => {
      return state.caseQuizListPagination;
    },
    getAllQuizzes: (state) => {
      return state.allQuizzesList;
    },
    getQuizList: (state) => {
      return state.quizList;
    },
    getQuizListTotalLength: (state) => {
      return state.caseQuizListPagination.total;
    },
    getCurrentQuiz: (state) => {
      return state.currentQuiz;
    },
    getQuizCaseListBusy: (state) => {
      return state.caseQuizListLoading;
    },
    getQuizStartedId: (state) => () => {
      return state.quizStarted.id;
    },
    getQuizCurrentCaseIndex: (state) => () => {
      return state.quizStarted.currentCaseIndex;
    },
  },

  mutations: {
    setQuizPagination(state, pagination) {
      state.caseQuizListPagination = {
        ...state.caseQuizListPagination,
        current_page: pagination.current_page,
        per_page: pagination.per_page,
        total: pagination.total,
        last_page: pagination.last_page,
      };
    },
    removeQuiz(state, id) {
      state.quizList = state.quizList.filter((quiz) => quiz.id !== id);
    },
    setQuizCaseListBusy(state, loading) {
      state.caseQuizListLoading = loading;
    },
    // setQuizList(state, quizData) {
    //   state.quizList = [...state.quizList, ...quizData];
    // },
    setQuizList(state, quizData) {
      state.quizList.push(...quizData);
    },
    replaceQuizList(state, quizData) {
      state.quizList = quizData;
    },
    setAllQuizzesList(state, quizData) {
      state.allQuizzesList = [...state.allQuizzesList, ...quizData];
    },
    setQuizCurrentCaseIndex(state, index) {
      state.quizStarted.currentCaseIndex = index;
    },
    setQuizStartedId(state, quizStarted) {
      state.quizStarted.id = quizStarted;
    },
    setQuizListCurrentPage(state, currentPage) {
      state.caseQuizListPagination.current_page = currentPage;
    },
  },

  actions: {
    updateQuizStartedId({ commit }, quizStarted) {
      commit('setQuizStartedId', quizStarted);
    },

    updateQuizCurrentCaseIndex({ commit }, index) {
      commit('setQuizCurrentCaseIndex', index);
    },

    async createNewQuiz({ commit }, { groupId, obj }) {
      try {
        const res = await this._vm.$api('groups.quizzes.create', { caseGroup: groupId }, obj);
      } catch (err) {
        console.log(err);
      }
    },

    async getQuizzesList({ state, commit }, { groupId, page = null, action = ACTION_APPEND }) {
      if (
        state.caseQuizListPagination.current_page !== state.caseQuizListPagination.last_page ||
        action === ACTION_REPLACE
      ) {
        if (!state.setCaseListBusy) commit('setQuizCaseListBusy', true);

        const _page = page || 1;
        commit('setQuizListCurrentPage', _page);

        let currentPage = state.caseQuizListPagination?.current_page ?? 1;
        let perPage = state.caseQuizListPagination?.per_page ?? 12;

        try {
          const response = await this._vm.$api('groups.quizzes.index', {
            caseGroup: groupId,
            author: true,
            limit: perPage,
            page: currentPage,
          });
          if (response.data) {
            const res = response.data;
            if (action === ACTION_APPEND) {
              commit('setQuizList', res.data);
            }

            if (action === ACTION_REPLACE) {
              commit('replaceQuizList', res.data);
            }
            commit('setQuizPagination', res.meta);
            commit('setQuizCaseListBusy', false);
          }
        } catch (err) {
          console.log(err);
          commit('setQuizCaseListBusy', false);
        }
      }
    },

    async getAllQuizzesList({ commit, dispatch }) {
      commit('setQuizCaseListBusy', true);
      try {
        const response = await this._vm.$api('admin.quizzes.index');
        if (response.data) {
          const res = response.data;
          commit('setAllQuizzesList', res.data);
          commit('setQuizCaseListBusy', false);
        }
      } catch (err) {
        console.log(err);
        commit('setQuizCaseListBusy', false);
      }
    },

    removeQuizFromList({ commit }, id) {
      commit('removeQuiz', id);
    },
  },
};
